const DownloadExportData = (data, filename) => {
    if (data) {
        const blob = new Blob([data], { type: 'text/csv' });

        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = filename ? filename : 'exported_data.csv';

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    }
};

export default DownloadExportData;